<app-pagetitle title="{{nameModal}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header">
        <div class="row"  *hasDenied="{nivel:idSprNivel, app: constant.PROYECTOS}">
          <div class="col-sm-6 text-sm-right">
            <button *hasPermission="{app: constant.PROYECTOS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
          </div>
        </div>
      </div>


      <div class="container card-body table-responsive">
        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Nombre</th>
              <th>Fecha inicio</th>
              <th>Fecha fin</th>
              <th>Estado</th>
              <th>Etapa</th>
              <th>Resumen Ejecutivo</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of dataObjetivoProyecto;let indice=index">
              <td>{{indice+1}}</td>
              <td>{{row.nombreProyecto}}</td>
              <td>{{row.fechaInicio  | date: 'dd-MM-yyyy'}}</td>
              <td>{{row.fechaFin  | date: 'dd-MM-yyyy'}}</td>
              <td>{{((row.estado == '1')? 'Activo': 'Inactivo')}}</td>
              <td class="text-center">
                <div class="row">
                  <button type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Agregar etapa" (click)="etapaInit(row)">
                    <i class="fas fa-tasks fa-lg"></i>
                  </button>
                </div>
              </td>
              <td class="text-center">
                <div class="row">
                  <button type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Agregar resumen ejecutivo" (click)="resumenEjecutivo(row)">
                    <i class="fas fa-file fa-lg"></i>
                  </button>
                </div>
              </td>
              <td class="text-center">
                <div class="row"  *hasDenied="{nivel:idSprNivel, app: constant.PROYECTOS}">
                  <button  *hasPermission="{app: constant.PROYECTOS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="edit(row)">
                    <i class="fas fa-pencil-alt fa-lg"></i>
                  </button>
                  <button *hasPermission="{app: constant.PROYECTOS, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0 " title="Eliminar este registro" (click)="delete(row.idSprProyecto)">
                    <i class="fas fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-proyecto" [isDelete]="true"
  (confirmation)="confirmDelete()"></jw-modal>
<!-- MODAL PARA CREAR Y EDITAR -->
<jw-modal id="{{nameModal}}" #modalChild>
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{nameModal}}</h3>
        <button type="button" class="btn-close" (click)="modalEditClose();" aria-label="Close"></button>
      </div>

      <div class="modal-body px-5">
        <form class="needs-validation" novalidate id="formProyecto" [formGroup]="formProyecto" autocomplete="off">
          <input type="hidden" id="idSprProyecto" formControlName="idSprProyecto">
          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="nombre" class=" form-control-label text-md-right"><b>Unidad:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <input class="form-control" style="background-color: #f5f4f4;" autocomplete="off" readonly="readonly" required="true" value="{{nombreUnidad}}">
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="idSprObjetivo" class=" form-control-label text-md-right"><b>Objetivo:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <select #objetivos class="form-select form-control-sm" id="idSprObjetivo" formControlName="idSprObjetivo" required="true" (ngModelChange)="obtenerEstategias($event)" [ngClass]="{'is-invalid': this.formProyecto.get('idSprObjetivo')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('idSprObjetivo')?.errors,}">
                <option *ngFor="let objetivo of dataObjetivo" [ngValue]="objetivo.idSprObjetivo" value="{{ objetivo.idSprObjetivo }}">
                  {{objetivo.nombre}}
                </option>
              </select>   
              <div class="col text-danger">
                <small class="font-italic" *ngIf="this.formProyecto.get('idSprObjetivo')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
              </div>
            </div>
          </div>

          <div *ngIf="idSprNivelN5 != nivelSelect" class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="idSprEstrategia" class=" col-form-label text-md-right"><b>Estratégia:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <select id="idSprEstrategia" class="form-select form-control-sm" formControlName="idSprEstrategia" required="true" 
              [ngClass]="{'is-invalid': this.formProyecto.get('idSprEstrategia')?.errors && this.formSubmitted, 'is-valid': !this.formProyecto.get('idSprEstrategia')?.errors,}">
                <option *ngFor="let estrategia of dataEstrategias" [value]="estrategia.idSprEstrategia">
                  {{estrategia.nombre}}
                </option>
              </select>
              <div class="col text-danger">
                <small class="font-italic" *ngIf="this.formProyecto.get('idSprEstrategia')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
              </div>
            </div>
          </div>

          <div class="form-group row mb-2">
            <div class="col col-md-2 text-md-right">
              <label for="estado" class="col-form-label text-md-right"><b>Estado:</b></label>
            </div>
            <div class="col-12 col-md-10">
              <select class="form-select " id="estado" formControlName="estado" required="true" [ngClass]="{'is-invalid': this.formProyecto.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('estado')?.errors,}">
                <option [value]="item.value" *ngFor="let item of selectItems">{{item.label}}
                </option>
              </select>
              <div class="col text-danger">
                <small class="font-italic" *ngIf="this.formProyecto.get('estado')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
              </div>
            </div>
          </div>

          <div id="accordion1" class="mb-3">
            <div class="card mb-1">
              <div class="card-header py-0 px-0 my-0" id="heading1">
                <h5 class="accordion-header py-0" id="heading1">
                  <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#detalle" aria-expanded="true" aria-expanded="true" aria-controls="collapseOne">
                    {{"Detalle del proyecto" }}
                  </a>
                </h5>
              </div>
              <div id="detalle" class="collapse" aria-labelledby='abcd' data-bs-parent="#accordion4">
                <div class="card-body">
                  <div class="row ">
                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="idSprProyecto"
                          class=" form-control-label text-md-right"><b>Nombre:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <textarea type="text" class="form-control" required="true" formControlName="nombreProyecto" placeholder="Nombre" maxlength="1500"  rows="3" cols="30" [ngClass]="{ 'is-invalid': this.formProyecto.get('nombreProyecto')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('nombreProyecto')?.errors,}">
                        </textarea>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('nombreProyecto')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="idSprProyecto" class=" form-control-label text-md-right"><b>Objetivo general:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <textarea type="text" class="form-control" required="true" formControlName="objetivoGeneral" placeholder="Objetivo general" maxlength="1500"  rows="3" cols="30" [ngClass]="{ 'is-invalid': this.formProyecto.get('objetivoGeneral')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('objetivoGeneral')?.errors,}">
                        </textarea>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('objetivoGeneral')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="idSprProyecto" class=" form-control-label text-md-right"><b>Objetivo específico:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <textarea type="text" class="form-control" required="true" formControlName="objetivoEspecifico" placeholder="Objetivo específico" maxlength="1500"  rows="3" cols="30" [ngClass]="{ 'is-invalid': this.formProyecto.get('objetivoEspecifico')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('objetivoEspecifico')?.errors,}">
                        </textarea>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('objetivoEspecifico')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right ">
                        <label for="idSprProyecto"
                          class="col-form-label text-md-right"><b>Descripción:</b>
                        </label>
                      </div>
                      <div class="col-12 col-md-10">
                        <textarea type="text" class="form-control" maxlength="3000" [(ngModel)]="textoDescripcionValue" (keyup)="onKey($event)" rows="8" cols="30" id="descripcion" placeholder="Descripción" formControlName="descripcion" [ngClass]="{'is-invalid':this.formProyecto.get('descripcion')?.errors && this.formSubmitted,'is-valid': this.formProyecto.value.descripcion}">
                        </textarea>
                        <div id="contador">{{ contador }} caracteres restantes</div>
                      </div>
                    </div>

                    <div class="form-group row mb-2 ">
                      <div class="col col-md-2 text-md-right">
                        <label for="beneficiosCualitativos" class=" form-control-label text-md-right"><b>Beneficios cualitativos:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <textarea class="form-control" maxlength="500" id="beneficiosCualitativos" placeholder="Beneficios cualitativos" formControlName="beneficiosCualitativos" [ngClass]="{'is-invalid':this.formProyecto.get('beneficiosCualitativos')?.errors && this.formSubmitted,'is-valid': this.formProyecto.value.beneficiosCualitativos}"></textarea>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="restricciones" class=" form-control-label text-md-right"><b>Restricciones:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <textarea class="form-control" maxlength="300" id="restricciones" placeholder="Restricciones" formControlName="restricciones" [ngClass]="{'is-invalid':this.formProyecto.get('restricciones')?.errors && this.formSubmitted,'is-valid': this.formProyecto.value.restricciones}"></textarea>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="numContratoPrincipal" class=" form-control-label text-md-right"><b>Num. Contrato principal:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <textarea class="form-control" maxlength="50" id="numContratoPrincipal" placeholder="Numero de contrato principal" formControlName="numContratoPrincipal" [ngClass]="{'is-invalid':this.formProyecto.get('numContratoPrincipal')?.errors && this.formSubmitted,'is-valid': this.formProyecto.value.numContratoPrincipal}"></textarea>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="idSprTitular" class=" form-control-label text-md-right"><b>Patrocinador ejecutivo:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <select class="form-select col-9" id="idSprTitular" formControlName="idSprTitular" required="true" [ngClass]="{'is-invalid': this.formProyecto.get('idSprTitular')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('idSprTitular')?.errors,}">
                          <option *ngFor="let row of dataResponsable" value={{row.idSprTitular}}>
                            {{row.nombres}}
                          </option>
                        </select>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('idSprTitular')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="idSprEquipoGerencial" class=" form-control-label text-md-right"><b>Líder del proyecto:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <select class="form-select col-9" id="idSprEquipoGerencial" formControlName="idSprEquipoGerencial" required="true" [ngClass]="{'is-invalid': this.formProyecto.get('idSprEquipoGerencial')?.errors && this.formSubmitted, 'is-valid': !this.formProyecto.get('idSprEquipoGerencial')?.errors,}">
                          <option *ngFor="let row of dataLiderProyecto" value={{row.idSprEquipoGerencial}}>
                            {{row.nombres}}
                          </option>
                        </select>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('idSprEquipoGerencial')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>
                    </div>


                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="idSprTipoProyecto" class=" form-control-label text-md-right"><b>Tipo de proyecto:</b></label>
                      </div>
                      <div class="col-12 col-md-4">
                        <select class="form-select col-12" id="idSprTipoProyecto" formControlName="idSprTipoProyecto" required="true" [ngClass]="{'is-invalid': this.formProyecto.get('idSprTipoProyecto')?.errors && this.formSubmitted, 'is-valid': !this.formProyecto.get('idSprTipoProyecto')?.errors,}">
                          <option *ngFor="let tipo of dataTipoProyecto" value={{tipo.idSprComun}}>
                            {{tipo.nombre}}
                          </option>
                        </select>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('idSprTipoProyecto')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>

                      <div class="col col-md-2 text-md-right">
                        <label for="idSprTipoCliente" class=" form-control-label text-md-right"><b>Tipo de beneficiario:</b></label>
                      </div>
                      <div class="col-12 col-md-4">
                        <select class="form-select col-9" formControlName="idSprTipoCliente" required="true" [ngClass]="{'is-invalid': this.formProyecto.get('idSprTipoCliente')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('idSprTipoCliente')?.errors,}">
                          <option *ngFor="let catCliente of dataCatComun" value={{catCliente.idSprComun}}>
                            {{catCliente.nombre}}
                          </option>
                        </select>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('idSprTipoCliente')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row mb-2">
                      <div class=" col col-md-2 text-md-right">
                          <label for="fechaInicio" class=" form-control-label text-md-right pt-1"><b>Fecha inicio:</b></label>
                      </div>
                      <div class="col-12 col-md-4">
                          <input type="date" class="form-control" required="true" placeholder="fechaInicio" formControlName="fechaInicio" [ngClass]="{'is-invalid': this.formProyecto.get('fechaInicio')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('fechaInicio')?.errors,}" />
                          <small class="invalid-feedback" *ngIf="this.formProyecto.get('fechaInicio')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                          <div class="col text-danger">
                              <span class="font-italic" *ngIf="this.formProyecto.get('fechaInicio').errors?.fechaInicio">La fecha debe estar comprendida entre
                                  {{this.formProyecto.get('fechaInicio')?.errors.fechaInicio}} y {{this.formProyecto.get('fechaInicio')?.errors.fechaFin}}
                              </span>
                          </div>
                      </div>

                      <div class=" col col-md-2 text-md-right">
                        <label for="fechaFin" class=" form-control-label text-md-right pt-1"><b>Fecha fin:</b></label>
                      </div>
                      <div class="col-12 col-md-4">
                        <input type="date" class="form-control" required="true" placeholder="Fecha Fin" formControlName="fechaFin" [ngClass]="{'is-invalid': this.formProyecto.get('fechaFin')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('fechaFin')?.errors,}" />
                        <small class="invalid-feedback"*ngIf="this.formProyecto.get('fechaFin')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        <div class="col text-danger">
                            <span class="font-italic" *ngIf="this.formProyecto.get('fechaFin').errors?.fechaFin">La fecha debe estar comprendida entre {{this.formProyecto.get('fechaFin')?.errors.fechaInicio}} y {{this.formProyecto.get('fechaFin')?.errors.fechaFin}}
                            </span>
                        </div>
                    </div>
                  </div>      
                    

                    <div class="form-group row mb-2">
                      <div class="col col-md-2 text-md-right">
                        <label for="idSprViabilidadTecnica"
                          class=" form-control-label text-md-right"><b>Viabilidad técnica:</b></label>
                      </div>
                      <div class="col-12 col-md-10">
                        <select class="form-select" required="true" formControlName="idSprViabilidadTecnica" [ngClass]="{'is-invalid':this.formProyecto.get('idSprViabilidadTecnica')?.errors && this.formSubmitted,'is-valid': this.formProyecto.value.idSprViabilidadTecnica}">
                          <option *ngFor="let viabilidad of dataViabilidadTecnica " value={{viabilidad.idSprComun}}>
                            {{viabilidad.nombre}}
                          </option>
                        </select>
                        <div class="col text-danger">
                          <small class="font-italic" *ngIf="this.formProyecto.get('idSprViabilidadTecnica')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="accordion2" class="mb-3">
            <div class="card mb-1">
              <div class="card-header py-0 px-0 my-0" id="heading2">
                <h5 class="accordion-header py-0" id="heading2">
                  <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#localImpacto" aria-expanded="true" aria-expanded="true" aria-controls="collapseTwo">
                    {{"Localización" }}
                  </a>
                </h5>
              </div>
              <div id="localImpacto" class="collapse" aria-labelledby='abcd' data-bs-parent="#accordion1">
                <div class="card-body">
                  <div class="row ">
                    <div class="col-md-6">
                      <h4 class="header-title">Estructura organizacional
                      </h4>
                      <div class="card flex justify-content-center">
                        <p-tree [value]="unidades" [filter]="true" selectionMode="single" [(selection)]="selectedFile" (onNodeSelect)="nodeSelect($event)" scrollHeight="300px" (onNodeExpand)="nodeExpand($event)">
                        </p-tree>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <h4 class="header-title">Datos localidad impacto</h4>
                      <div class="form-floating mb-2">
                        <textarea type="text" id="localidadImpacto" class="form-control form-control-sm" formControlName="localidadImpacto" [ngClass]="{ 'is-invalid': this.formProyecto.get('localidadImpacto')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('localidadImpacto')?.errors,}">
                        </textarea>
                        <label for="localidadImpacto">Nombre</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="accordion3" class="mb-3">
            <div class="card mb-1">
              <div class="card-header py-0 px-0 my-0" id="heading3">
                <h5 class="accordion-header py-0" id="heading3">
                  <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#area" aria-expanded="true" aria-expanded="true" aria-controls="collapseThree">
                    {{"Áreas de la unidad" }}
                  </a>
                </h5>
              </div>
              <div id="area" class="collapse" aria-labelledby='abcd' data-bs-parent="#accordion2">
                <div class="card-body">
                  <div class="row">
                    <div>
                      <table datatable class="table table-striped table-bordered row-border hover">
                      <thead>
                        <tr>
                          <th>Nro.</th>
                          <th>Área</th>
                          <th>Check</th>
                        </tr>
                      </thead>
                        <tbody>
                        <tr *ngFor="let dato of dataGetAres; let indice = index">
                          <td>{{ indice + 1 }}</td>
                          <td>{{ dato.nombre }}</td>
                          <td> <label>
                            <!--<input type="checkbox" [checked]="esSeleccionado(dato)" (change)="actualizarSeleccion($event, dato)">-->
                            <input type="checkbox" class="form-check-input"
                                    (change)="onChangeAreas($event,dato.idSprArea)" id={{dato.idSprArea}}
                                    name="option1{{indice}}" value={{dato.idSprArea}} [checked]="dato.checked">
                          </label></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="accordion4" class="mb-3">
            <div class="card mb-1">
              <div class="card-header py-0 px-0 my-0" id="heading4">
                <h5 class="accordion-header py-0" id="heading4">
                  <a class="accordion-button py-2 text-reset" data-bs-toggle="collapse" href="#participantes" aria-expanded="true" aria-expanded="true" aria-controls="collapseFour">
                    {{"Participantes del proyecto" }}
                  </a>
                </h5>
              </div>
              <div id="participantes" class="collapse" aria-labelledby='abcd'
                data-bs-parent="#accordion3">
                <div class="card-body">
                  <div class="row ">              
                    <div class="form-group row mb-2">
                      <div class="col col-md-3 text-md-right">
                        <label for="cedula" class=" form-control-label text-md-right"><b>Cédula:</b></label>
                      </div>
                      <div class="col col-md-6 text-md-right">
                        <input type="text" maxlength="10" onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false" class="form-control" required="true" formControlName="cedula" [ngClass]="{'is-invalid': this.formProyecto.get('cedula')?.errors  && this.formSubmitted,'is-valid':!this.formProyecto.get('cedula')?.errors, }">
                      </div>
                      <div class="col col-md-3">
                        <button type="button" class="btn btn-info" (click)="buscaPersona()">Buscar&nbsp;</button>
                      </div>
                    </div>
                    <div class="col text-danger">
                      <small class="invalid-feedback" *ngIf="this.formProyecto.get('cedula')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                    </div>

                    <div class="form-group row mb-2">
                      <div class="col col-md-3 text-md-right">
                        <label for="informacion" class="form-control-label text-md-right pt-1"><b>Nombre:</b>
                        </label>
                      </div>
                      <div class="col-12 col-md-8">
                        <input type="text" class="form-control col-9" [readOnly]="true" style="background-color: #f5f4f4" required="true" formControlName="nombreParticipante" value="{{continuar2}}" />
                      </div>
                    </div>

                  <div class="form-group row mb-2">
                    <div class="col col-md-3 text-md-right">
                      <label for="cargoFuncion" class=" form-control-label text-md-right"><b>Cargo/Funcion::</b></label>
                    </div>
                    <div class="col col-md-6 text-md-right">
                      <input type="text" id="cargoFuncion" class="form-control" required="true" formControlName="cargoFuncion" [ngClass]="{ 'is-invalid': this.formProyecto.get('cargoFuncion')?.errors && this.formSubmitted,'is-valid': !this.formProyecto.get('cargoFuncion')?.errors,}">
                    </div>
                    <div class="col col-md-3">
                      <button type="button" class="btn btn-info justify-content-md-end" (click)="pushParticipante()">Agregar</button>
                    </div>
                  </div>
                  </div>
                  <div class="row">
                    <table class="table table-striped table-bordered row-border hover">
                      <thead>
                        <tr>
                          <th>Nro.</th>
                          <th>Nombre</th>
                          <th>Cédula</th>
                          <th>Cargo/Funcion</th>
                          <th>Fecha inicio</th> 
                          <th>Estado</th>
                          <th>Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let subSistem of inputsAnteriores; let indice = index;  ">
                          <td>{{ indice + 1 }}</td>
                          <td>{{ subSistem.gradoNombres}}</td>
                          <td>{{ subSistem.cedula }}</td>
                          <td>{{ subSistem.cargoFuncion }}</td>
                          <td>{{ subSistem.fechaInicio }}</td>
                          <td *ngIf="subSistem.estado==1">Activo</td>
                          <td *ngIf="subSistem.estado==2">Inactivo</td>
                          <td class="text-center col-sm-auto">
                            <button type="button" class="btn btn-sm btn-link waves-effect" title="Eliminar este registro" (click)="removeInputAnteriores(indice, subSistem)">
                              <i class="fas fa-trash-alt fa-lg"></i>
                            </button>
                          </td>
                        </tr>
                        <tr
                          *ngFor="let subSistem of participantesNuevos; let indice = index;  ">
                          <td>{{ indice + 1 }}</td>
                          <td>{{ subSistem.nombre }}</td>
                          <td>{{ subSistem.cedula }}</td>
                          <td>{{ subSistem.cargoFuncion }}</td>
                          <td>{{ subSistem.fechaInicial }}</td>
                          <td *ngIf="subSistem.estadoParticipa==1">Activo</td>
                          <td *ngIf="subSistem.estadoParticipa==2">Inactivo</td>
                          <td>
                            <button type="button"
                              class="btn btn-sm btn-link waves-effect"
                              title="Eliminar este registro"
                              (click)="removeInput(indice)">
                              <i class="fas fa-trash-alt fa-lg"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect" (click)="modalEditClose();">Cerrar</button>
        <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
      </div>
    </div>
  </div>
</jw-modal>

<!-- Inicio modal detalle proyeto -->
<jw-modal id="{{nameModal1}}">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:5%; max-width: 75%; max-height: 90%;">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{ nameModal1 }}</h3>
        <button type="button" class="btn-close" (click)="modalEditClose();" aria-label="Close"></button>
      </div>
      <div class="modal-body px-5">
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="etapa" role="tabpanel" aria-labelledby="etapa-tab">
            <app-etapa [data]="etapa" [proyecto]="proyectoActual"></app-etapa>
          </div>
        </div>
      </div>
    </div>
  </div>
</jw-modal>

<jw-modal id="{{modalResumenEjecutivo}}">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:5%; max-width: 75%; max-height: 90%;">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{ modalResumenEjecutivo }}</h3>
        <button type="button" class="btn-close" (click)="modalEditClose()" aria-label="Close"></button>
      </div>
      <div class="modal-body pT-4">
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="etapa" role="tabpanel" aria-labelledby="etapa-tab">
            <app-resumen-ejecutivo [data]="etapa" [proyecto]="proyectoActual"></app-resumen-ejecutivo>
          </div>
        </div>
      </div>
    </div>
  </div>
</jw-modal>